import { render, staticRenderFns } from "./LoginRecover.vue?vue&type=template&id=2c572d06&"
import script from "./LoginRecover.vue?vue&type=script&lang=js&"
export * from "./LoginRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports